import Observable from "zen-observable";
import AuthStream from "@irati/auth/streams/auth";
import UnauthedStream from "@irati/auth/streams/unauthed";
import GlobalStream from "@irati/auth/streams/global";
/**
 * @description: We listen to various auth streams where branding can come from.
 * Heirachy of authed (e.g. logged in user), unauthed (e.g. tenant page) then global stylings (general Perkbox stlyings)
 */
var BrandingListener = /** @class */ (function () {
    function BrandingListener() {
        this.authedListener = null;
        this.unauthedListener = null;
        this.globalListener = null;
        this.authedBranding = null;
        this.unauthedBranding = null;
        this.globalBranding = null;
    }
    BrandingListener.prototype.subscribe = function (onNext) {
        var _this = this;
        return new Observable(function (observer) {
            // Due to circular refs, we need to delay this to next JS tick using setTimeout
            setTimeout(function () {
                if (!_this.authedListener) {
                    _this.listenToStream("authedListener", AuthStream, function (branding) {
                        _this.authedBranding = branding;
                        _this.sendBranding(observer);
                    });
                }
                if (!_this.unauthedListener) {
                    _this.listenToStream("unauthedListener", UnauthedStream, function (branding) {
                        _this.unauthedBranding = branding;
                        _this.sendBranding(observer);
                    });
                }
                if (!_this.globalListener) {
                    _this.listenToStream("globalListener", GlobalStream, function (branding) {
                        _this.globalBranding = branding;
                        _this.sendBranding(observer);
                    });
                }
            });
            return function () { };
        }).subscribe(onNext);
    };
    BrandingListener.prototype.sendBranding = function (observer) {
        var branding = this.get();
        if (branding) {
            observer.next(branding);
        }
    };
    BrandingListener.prototype.get = function () {
        return this.authedBranding || this.unauthedBranding || this.globalBranding || null;
    };
    BrandingListener.prototype.listenToStream = function (key, service, update) {
        var _this = this;
        this[key] = service.subscribe(function (auth) {
            if (auth && auth.branding) {
                update(auth.branding);
            }
        }, undefined, function () {
            update(null);
            _this.listenToStream(key, service, update);
        });
    };
    return BrandingListener;
}());
export default new BrandingListener();
